export default __webpack_public_path__ + "static/media/port8.cca58e08.png";